<script>
export default {
  name: 'ViewCutscene'
}
</script>

<template>
  <div class="c-view-cutscene">
    <div class="c-view-cutscene-content">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">

.c-view-cutscene-content {
  @include buffer-loose-even;
}

</style>
